import { INotificationSetting } from '../../../types/notifications';
import { DELIVERY_METHOD } from 'src/constants/deliveryTypes';
import { defaultTTranslate, ShortCode } from 'src/constants/main';
import { ORDER_STATUS } from 'src/constants/order';
import { localeStore } from 'src/mobx/localesStore';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types';

export const defaultOrderStatusNotificationSetting: INotificationSetting = {
  id: 0,
  subject: defaultTTranslate,
  message: defaultTTranslate,
  deliveryMethod: DELIVERY_METHOD.APP_NOTIFICATION,
  event: ORDER_STATUS.PENDING,
  status: 0,
};

export const orderStatusNotificationSettingEventPickerOptions = (): IPickerOption[] => {
  return [
    { value: ORDER_STATUS.WAITING_FOR_PAYMENT, label: localeStore.t(ORDER_STATUS.WAITING_FOR_PAYMENT + '_status') },
    { value: ORDER_STATUS.PENDING, label: localeStore.t(ORDER_STATUS.PENDING + '_status') },
    { value: ORDER_STATUS.ACCEPTED, label: localeStore.t(ORDER_STATUS.ACCEPTED + '_status') },
    { value: ORDER_STATUS.PROCESSING, label: localeStore.t(ORDER_STATUS.PROCESSING + '_status') },
    { value: ORDER_STATUS.PICKEDUP, label: localeStore.t(ORDER_STATUS.PICKEDUP + '_status') },
    { value: ORDER_STATUS.OUT_FOR_DELIVERY, label: localeStore.t(ORDER_STATUS.OUT_FOR_DELIVERY + '_status') },
    { value: ORDER_STATUS.ASSIGNED, label: localeStore.t(ORDER_STATUS.ASSIGNED + '_status') },
    { value: ORDER_STATUS.WAITING_FOR_PICKUP, label: localeStore.t(ORDER_STATUS.WAITING_FOR_PICKUP + '_status') },
    { value: ORDER_STATUS.COMPLETED, label: localeStore.t(ORDER_STATUS.COMPLETED + '_status') },
    { value: ORDER_STATUS.RETURNED, label: localeStore.t(ORDER_STATUS.RETURNED + '_status') },
    { value: ORDER_STATUS.CANCELED, label: localeStore.t(ORDER_STATUS.CANCELED + '_status') },
  ];
};

export const orderStatusNotificationSettingShortCodePickerOptions = (): IPickerOption[] => {
  return [
    { value: ShortCode.CLIENT_NAME, label: localeStore.t('client_name') },
    { value: ShortCode.ORDER_NUMBER, label: localeStore.t('order_number_1') },
    { value: ShortCode.APP_LINK, label: localeStore.t('app_link') },
  ];
};
